import { Directive, ElementRef, HostListener, Injector } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[tbOnlyLetter]',
})
export class TBOnlyLetterDirective {
  constructor(private elementRef: ElementRef, private injector: Injector) {
  }

  @HostListener('input', ['$event'])
  onInputChange(event) {
    const initalValue = this.elementRef.nativeElement.value;
    this.elementRef.nativeElement.value = initalValue.replace(
      /[^a-zA-Z\u0130\u011E\u015E\u00C7\u00FC\u011F\u015F\u00E7\u00F6\u00D6\u0131\u00DC\u0020]+/g,
      '',
    );
    // Turkish characters (ö, ğ, ü, etc.) could not be formatted.Therefore, manual addition was performed. Example : u0130: İ, u015E: Ş
    if (initalValue !== this.elementRef.nativeElement.value) {
      event.stopPropagation();
      const ngControl = this.injector.get<NgControl>(NgControl, null);
      if (ngControl && ngControl.control) {
        ngControl.control.setValue(this.elementRef.nativeElement.value);
      }
    }
  }
}
